//静态常量
const state = {
  name:''
};
const mutations = {
    getPower(state, data) {
        state.name = data
    },
};
const actions = {

};
export default {
    state,
    mutations,
    actions
};
